import { render, staticRenderFns } from "./PropertyAdditionalCharge.vue?vue&type=template&id=03cbdb8b&"
import script from "./PropertyAdditionalCharge.vue?vue&type=script&lang=js&"
export * from "./PropertyAdditionalCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports